export default __webpack_public_path__ + "static/media/m-qs-banner.5541559d.png";